export var TypeActionQuickSkip;
(function (TypeActionQuickSkip) {
    TypeActionQuickSkip["SkipProduction"] = "QuickSkip > SkipProduction";
    TypeActionQuickSkip["SkipConstruction"] = "QuickSkip > SkipConstruction";
    TypeActionQuickSkip["Cancel"] = "QuickSkip > Cancel";
})(TypeActionQuickSkip || (TypeActionQuickSkip = {}));
export var actionQuickSkipProductionSkip = function (building) { return ({
    building: building,
    type: TypeActionQuickSkip.SkipProduction,
}); };
export var actionQuickSkipConstructionSkip = function (building, action) { return ({
    action: action,
    building: building,
    type: TypeActionQuickSkip.SkipConstruction,
}); };
export var actionQuickSkipCancel = function () { return ({
    type: TypeActionQuickSkip.Cancel,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/actionQuickSkip.ts
// module id = 571
// module chunks = 3